export const testimonialsDefault = [
  {
    order: {
      id: 146964,
      title_private: 'N',
      title: 'Java assignment',
      paper_type: 'Java',
      pages_qty: '2',
      status: '100',
      status_title: 'Completed',
      rating_dt_date: 'Nov 29, 2019',
      rating_dt_time: '10:53 PM',
      rating_dt_timeago: '4 days ago at 11:21 PM',
      rating_dt_in2days: 'Y',
      rating_writer: '10',
      rating_writer_comment:
        "My java assignment was done very fast, I didn't even count on such a performance. Thanks!",
      rating_customer: '10',
      rating_customer_comment: 'Loading...',
      discipline_title: 'loading...',
    },
    writer: {
      pen_name_slug: 'tonnytipper',
      pen_name: 'tonnytipper',
      avatar: '/w3t_avatar/writer/296/tonnytipper.png',
      rating: '9.1',
      writer_status: '1100',
      orders_finished_qty: '257',
      warning_qty: '0',
      award_qty: '1',
      auth: {
        online_status: 'online',
      },
    },
  },
  {
    order: {
      id: 151816,
      title_private: 'N',
      title: 'java',
      paper_type: 'Java',
      pages_qty: '1',
      status: '100',
      status_title: 'Completed',
      rating_dt_date: 'Nov 29, 2019',
      rating_dt_time: '10:53 PM',
      rating_dt_timeago: '3 days ago at 4:45 PM',
      rating_dt_in2days: 'Y',
      rating_writer: '9',
      rating_writer_comment:
        "It's my first order online and I am very please with a chosen expert. Perfect",
      rating_customer: '10',
      rating_customer_comment: 'Loading...',
      discipline_title: 'loading...',
    },
    writer: {
      pen_name_slug: 'mariephysic',
      pen_name: 'MariePhysic',
      avatar: '/w3t_avatar/writer/126/writermeckler.png',
      rating: '9.91',
      writer_status: '1100',
      orders_finished_qty: '196',
      warning_qty: '0',
      award_qty: '1',
      auth: {
        online_status: 'online',
      },
    },
  },
  {
    order: {
      id: 111918,
      title_private: 'N',
      title: 'Python homework',
      paper_type: 'Python',
      pages_qty: '2',
      status: '100',
      status_title: 'Completed',
      rating_dt_date: '',
      rating_dt_time: '',
      rating_dt_timeago: '1 day ago at 10:32 AM',
      rating_dt_in2days: 'Y',
      rating_writer: '10',
      rating_writer_comment:
        'Easy to order, easy to work with you, guys. Good experience. ',
      rating_customer: '10',
      rating_customer_comment: 'Loading...',
      discipline_title: 'loading...',
    },
    writer: {
      pen_name_slug: 'funwriter',
      pen_name: 'funwriter',
      avatar: '/w3t_avatar/writer/349/funwriter.png',
      rating: '9.92',
      writer_status: '1100',
      orders_finished_qty: '3420',
      warning_qty: '0',
      award_qty: '1',
      auth: {
        online_status: 'online',
      },
    },
  },
  {
    order: {
      id: 115090,
      title_private: 'N',
      title: 'Programming project',
      paper_type: 'Python',
      pages_qty: '1',
      status: '100',
      status_title: 'Completed',
      rating_dt_date: 'Nov 29, 2019',
      rating_dt_time: '10:53 PM',
      rating_dt_timeago: '2 days ago at 7:30 AM',
      rating_dt_in2days: 'Y',
      rating_writer: '10',
      rating_writer_comment:
        'Responsible and responsive - everything as promised.',
      rating_customer: '10',
      rating_customer_comment: 'Loading...',
      discipline_title: 'loading...',
    },
    writer: {
      pen_name_slug: 'blazzie',
      pen_name: 'Blazzie',
      avatar: '/w3t_avatar/writer/103/oncomingstorm986.png',
      rating: '9.92',
      writer_status: '1100',
      orders_finished_qty: '7902',
      warning_qty: '0',
      award_qty: '1',
      auth: {
        online_status: 'online',
      },
    },
  },
  {
    order: {
      id: 118188,
      title_private: 'N',
      title: 'Hanoi tower solver',
      paper_type: 'Javascript',
      pages_qty: '2',
      status: '100',
      status_title: 'Completed',
      rating_dt_date: 'Nov 28, 2019',
      rating_dt_time: '10:53 PM',
      rating_dt_timeago: '1 day ago at 5:41 PM',
      rating_dt_in2days: 'Y',
      rating_writer: '9',
      rating_writer_comment:
        'Good job, fast delivery, nice conversation. Wil order more.',
      rating_customer: '10',
      rating_customer_comment: 'Loading...',
      discipline_title: 'loading...',
    },
    writer: {
      pen_name_slug: 'vivacoder',
      pen_name: 'VivaCoder',
      avatar: '/w3t_avatar/writer/299/vivacoder.png',
      rating: '9.92',
      writer_status: '1100',
      orders_finished_qty: '1610',
      warning_qty: '0',
      award_qty: '1',
      auth: {
        online_status: 'online',
      },
    },
  },
  {
    order: {
      id: 128762,
      title_private: 'N',
      title: 'Maze solver',
      paper_type: 'C++',
      pages_qty: '2',
      status: '100',
      status_title: 'Completed',
      rating_dt_date: '',
      rating_dt_time: '',
      rating_dt_timeago: '2 days ago at 1:12 PM',
      rating_dt_in2days: 'Y',
      rating_writer: '10',
      rating_writer_comment:
        'Very fast coding! Close to magic but done for real. Thanks.',
      rating_customer: '10',
      rating_customer_comment: 'Loading...',
      discipline_title: 'loading...',
    },
    writer: {
      pen_name_slug: 'mariephysic',
      pen_name: 'MariePhysic',
      avatar: '/w3t_avatar/writer/126/writermeckler.png',
      rating: '9.91',
      writer_status: '1100',
      orders_finished_qty: '196',
      warning_qty: '0',
      award_qty: '1',
      auth: {
        online_status: 'online',
      },
    },
  },
  {
    order: {
      id: 123502,
      title_private: 'N',
      title: 'Responsive page',
      paper_type: 'HTML',
      pages_qty: '2',
      status: '100',
      status_title: 'Completed',
      rating_dt_date: 'Nov 28, 2019',
      rating_dt_time: '10:53 PM',
      rating_dt_timeago: '5 days ago at 8:53 AM',
      rating_dt_in2days: 'Y',
      rating_writer: '7',
      rating_writer_comment:
        'Had to wait for my order to be noticed. But in the end, everything is fine.',
      rating_customer: '10',
      rating_customer_comment: 'Loading...',
      discipline_title: 'loading...',
    },
    writer: {
      pen_name_slug: 'tonnytipper',
      pen_name: 'tonnytipper',
      avatar: '/w3t_avatar/writer/296/tonnytipper.png',
      rating: '9.1',
      writer_status: '1100',
      orders_finished_qty: '257',
      warning_qty: '0',
      award_qty: '1',
      auth: {
        online_status: 'online',
      },
    },
  },
  {
    order: {
      id: 123758,
      title_private: 'N',
      title: 'php homework',
      paper_type: 'PHP',
      pages_qty: '2',
      status: '100',
      status_title: 'Completed',
      rating_dt_date: 'Nov 28, 2019',
      rating_dt_time: '10:53 PM',
      rating_dt_timeago: '1 day ago at 3:22 PM',
      rating_dt_in2days: 'Y',
      rating_writer: '9',
      rating_writer_comment: 'Well done. Professional coding, fast response.',
      rating_customer: '10',
      rating_customer_comment: 'Loading...',
      discipline_title: 'loading...',
    },
    writer: {
      pen_name_slug: 'vivacoder',
      pen_name: 'VivaCoder',
      avatar: '/w3t_avatar/writer/299/vivacoder.png',
      rating: '9.92',
      writer_status: '1100',
      orders_finished_qty: '1610',
      warning_qty: '0',
      award_qty: '1',
      auth: {
        online_status: 'online',
      },
    },
  },
  {
    order: {
      id: 136046,
      title_private: 'N',
      title: 'MATLAB assignment',
      paper_type: 'Matlab',
      pages_qty: '2',
      status: '100',
      status_title: 'Completed',
      rating_dt_date: 'Nov 27, 2019',
      rating_dt_time: '10:53 PM',
      rating_dt_timeago: '3 days ago at 11:22 AM',
      rating_dt_in2days: 'Y',
      rating_writer: '10',
      rating_writer_comment:
        "It was very helpful. The result is impressive, I wouldn't be able to do it myself.",
      rating_customer: '10',
      rating_customer_comment: 'Loading...',
      discipline_title: 'loading...',
    },
    writer: {
      pen_name_slug: 'blazzie',
      pen_name: 'Blazzie',
      avatar: '/w3t_avatar/writer/350/engrdylan.png',
      rating: '9.92',
      writer_status: '1100',
      orders_finished_qty: '7902',
      warning_qty: '0',
      award_qty: '1',
      auth: {
        online_status: 'online',
      },
    },
  },
];

export const latestOrdersDefault = {
  orders: [
    {
      order: 146964,
      rating_writer_comments:
        "My java assignment was done very fast, I didn't even count on such a performance. Thanks!",
      rating_customer: '10',
      rating_writer: '',
      rating_customer_comments: '',
      finish_dt_date: '4 days ago at 11:21 PM',
      finish_dt_time: '',
      order_title: 'Java assignment',
      order_title_private: '',
      discipline_title: 'Java',
      order_pages_qty: '1',
      order_paper_type: 'Essay (any type)',
      writer_pen_name_slug: 'tonnytipper',
      writer_pen_name: 'tonnytipper',
      writer_rating: '9.1',
      writer_orders_qty: '257',
      writer_avatar: '/w3t_avatar/writer/296/tonnytipper.png',
      position: 1,
      writer_award_qty: '',
    },
    {
      order: 151816,
      rating_writer_comments:
        "It's my first order online and I am very please with a chosen expert. Perfect",
      rating_customer: '9',
      rating_writer: '',
      rating_customer_comments: '',
      finish_dt_date: '3 days ago at 4:45 PM',
      finish_dt_time: '',
      order_title: 'java',
      order_title_private: '',
      discipline_title: 'Java',
      order_pages_qty: '1',
      order_paper_type: 'Coursework',
      writer_pen_name_slug: 'martinnnnn',
      writer_pen_name: 'Martinnnnn',
      writer_rating: '9.66',
      writer_orders_qty: '3492',
      writer_avatar: '/w3t_avatar/writer/315/martinnnnn.png',
      position: 1,
      writer_award_qty: '',
    },
    {
      order: 111918,
      rating_writer_comments:
        'Easy to order, easy to work with you, guys. Good experience.',
      rating_customer: '10',
      rating_writer: '',
      rating_customer_comments: '',
      finish_dt_date: '1 day ago at 10:32 AM',
      finish_dt_time: '',
      order_title: 'Python homework',
      order_title_private: '',
      discipline_title: 'Python',
      order_pages_qty: '3',
      order_paper_type: 'Argumentative essay',
      writer_pen_name_slug: 'funwriter',
      writer_pen_name: 'funwriter',
      writer_rating: '9.92',
      writer_orders_qty: '3420',
      writer_avatar: '/w3t_avatar/writer/349/funwriter.png',
      position: 1,
      writer_award_qty: '',
    },
    {
      order: 115090,
      rating_writer_comments:
        'Responsible and responsive - everything as promised.',
      rating_customer: '10',
      rating_writer: '',
      rating_customer_comments: '',
      finish_dt_date: '2 days ago at 7:30 AM',
      finish_dt_time: '',
      order_title: 'Programming project',
      order_title_private: '',
      discipline_title: 'Python',
      order_pages_qty: '1',
      order_paper_type: 'Paper type',
      writer_pen_name_slug: 'blazzie',
      writer_pen_name: 'Blazzie',
      writer_rating: '9.92',
      writer_orders_qty: '7902',
      writer_avatar: '/w3t_avatar/writer/350/engrdylan.png',
      position: 1,
      writer_award_qty: '',
    },
    {
      order: 118188,
      rating_writer_comments:
        'Good job, fast delivery, nice conversation. Wil order more.',
      rating_customer: '9',
      rating_writer: '',
      rating_customer_comments: '',
      finish_dt_date: '1 day ago at 5:41 PM',
      finish_dt_time: '',
      order_title: 'Hanoi tower solver',
      order_title_private: '',
      discipline_title: 'Javascript',
      order_pages_qty: '14',
      order_paper_type: 'Coursework',
      writer_pen_name_slug: 'vivacoder',
      writer_pen_name: 'VivaCoder',
      writer_rating: '9.92',
      writer_orders_qty: '1610',
      writer_avatar: '/w3t_avatar/writer/299/vivacoder.png',
      position: 1,
      writer_award_qty: '',
    },
    {
      order: 128762,
      rating_writer_comments:
        'Very fast coding! Close to magic but done for real. Thanks.',
      rating_customer: '10',
      rating_writer: '',
      rating_customer_comments: '',
      finish_dt_date: '2 days ago at 1:12 PM',
      finish_dt_time: '',
      order_title: 'Maze solver',
      order_title_private: '',
      discipline_title: 'C++',
      order_pages_qty: '6',
      order_paper_type: 'Argumentative essay',
      writer_pen_name_slug: 'martinnnnn',
      writer_pen_name: 'Martinnnnn',
      writer_rating: '9.66',
      writer_orders_qty: '3492',
      writer_avatar: '/w3t_avatar/writer/315/martinnnnn.png',
      position: 1,
      writer_award_qty: '',
    },
    {
      order: 123502,
      rating_writer_comments:
        'Had to wait for my order to be noticed. But in the end, everything is fine.',
      rating_customer: '7',
      rating_writer: '',
      rating_customer_comments: '',
      finish_dt_date: '5 days ago at 8:53 AM',
      finish_dt_time: '',
      order_title: 'Responsive page',
      order_title_private: '',
      discipline_title: 'HTML',
      order_pages_qty: '3',
      order_paper_type: 'Essay (any type)',
      writer_pen_name_slug: 'tonnytipper',
      writer_pen_name: 'tonnytipper',
      writer_rating: '9.1',
      writer_orders_qty: '257',
      writer_avatar: '/w3t_avatar/writer/296/tonnytipper.png',
      position: 1,
      writer_award_qty: '',
    },
    {
      order: 123758,
      rating_writer_comments: 'Well done. Professional coding, fast response.',
      rating_customer: '9',
      rating_writer: '',
      rating_customer_comments: '',
      finish_dt_date: '1 day ago at 3:22 PM',
      finish_dt_time: '',
      order_title: 'php homework',
      order_title_private: '',
      discipline_title: 'PHP',
      order_pages_qty: '1',
      order_paper_type: 'Argumentative essay',
      writer_pen_name_slug: 'vivacoder',
      writer_pen_name: 'VivaCoder',
      writer_rating: '9.92',
      writer_orders_qty: '1610',
      writer_avatar: '/w3t_avatar/writer/299/vivacoder.png',
      position: 1,
      writer_award_qty: '',
    },
    {
      order: 136046,
      rating_writer_comments:
        "It was very helpful. The result is impressive, I wouldn't be able to do it myself.",
      rating_customer: '10',
      rating_writer: '',
      rating_customer_comments: '',
      finish_dt_date: '3 days ago at 11:22 AM',
      finish_dt_time: '',
      order_title: 'MATLAB assignment',
      order_title_private: '',
      discipline_title: 'Matlab',
      order_pages_qty: '1',
      order_paper_type: 'Essay (any type)',
      writer_pen_name_slug: 'blazzie',
      writer_pen_name: 'Blazzie',
      writer_rating: '9.92',
      writer_orders_qty: '7902',
      writer_avatar: '/w3t_avatar/writer/350/engrdylan.png',
      position: 1,
      writer_award_qty: '',
    },
  ],
  pagination: [],
};
